module.exports = __webpack_public_path__ + "band_7.d93721ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/male_to_female/band_7.png
// module id = mR1b
// module chunks = 0